import React, { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import blueCedarLogo from "../../assets/favicons/official-cedar-logo.png";
import { useRequestAccessByPath } from "../../hooks/react-query/access-requests/useRequestAccessByPath";

export const AccessDenied = () => {
  const location = useLocation();
  const [requested, setRequested] = useState(false);
  const { requestAccessByPath } = useRequestAccessByPath();

  const firstPathSegment = location.pathname.split("/").filter(Boolean)[0];
  const showRequestButton = firstPathSegment && firstPathSegment !== "403";

  const handleRequestAccess = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      requestAccessByPath(location.pathname, {
        onSuccess: () => {
          setRequested(true);
          toast.success("Request for access has been received");
        },
        onError: () => toast.error("Failed to update your request, please try again later"),
      });
    },
    [location.pathname, requestAccessByPath]
  );

  return (
    <div className="form_body" id="login_form_body">
      <div className="header_section">
        <img src={blueCedarLogo} alt="" />
        <span className="header_section_wordmark">CEDAR</span>
      </div>
      <form className="error_form">
        <h3>Access denied</h3>
        <label>Sorry, you are not authorized to view this page.</label>
        {showRequestButton && (
          <a href="#" onClick={requested ? undefined : handleRequestAccess} style={{ marginTop: "1em" }}>
            {requested ? "Access requested" : "Request access"}
          </a>
        )}
        <a href="/">Return to homepage.</a>
      </form>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        draggable={false}
        pauseOnHover={false}
      />
    </div>
  );
};
